import {KeycloakService} from 'keycloak-angular';
import {ENDPOINT} from '@shared/enum/Enum';
import {inject, Injector, PLATFORM_ID} from '@angular/core';
import {AreaRiservataService} from './area-riservata.service';
import {RestService} from './rest.service';
import {isPlatformBrowser} from '@angular/common';
import {APP_CONFIG} from "../app-config.model";
import {map} from "rxjs/operators";
import {ConsentOrchestratorService} from "./consent-orchestrator.service";

export function keycloakInitService(keycloak: KeycloakService, injector: Injector): () => Promise<void> {
  return async (): Promise<void> => {
    const platformId = inject(PLATFORM_ID);
    const configEnv = inject(APP_CONFIG);
    if (!isPlatformBrowser(platformId)) {
      return;
    }
    const aRiservata = injector.get(AreaRiservataService);
    const isMFAActive = await aRiservata.checkIsMFAActive();
    console.log('isMFAActive: ', isMFAActive);
    if (isMFAActive) {
      // @ts-ignore
      await keycloak.init({
        config: {
          url: configEnv.REALM_SSO_PATH,
          realm: configEnv.REALM_NAME,
          clientId: configEnv.REALM_CLIENT_ID
        },
        initOptions: {
          onLoad: 'check-sso',
          silentCheckSsoRedirectUri:
            window.location.origin + '/silent-check-sso.html'
        }
      }).then(async () => {
        if (keycloak.isLoggedIn()) {
          const restService = injector.get(RestService);
          const consentOrchestrator = injector.get( ConsentOrchestratorService );
          await restService.post(configEnv.LOGINAPI + ENDPOINT.TRACEACCESSMFA, '').pipe(
            map( (res: any) => {
              consentOrchestrator.setUser(res.Id);
            })).toPromise();
        }
      });
    } else {
      console.info('Disabled MFA');
    }
  }
}
